import isEqual from 'lodash.isequal';

// Default values for jobs filters - filters matching these values are not counted
const defaultJobsFilters = {
  companyId: '',
  jobFunctionId: '',
  seniority: '',
  locations: [],
  remote: '',
  compensationAmountMinCents: null,
  compensationCurrency: 'USD',
  compensationPeriod: 'year',
  compensationOffersEquity: '',
  addedAfter: null,
  addedBefore: null,
  expirationWithin: '',
  featured: '',
  visibility: 'any',
  source: '',
  status: '',
  numberOfApplicants: null,
  hasPeopleFinderProject: 'any',
};

// Filter keys that should not be counted (e.g., internal state)
const blacklistedFiltersForCount = ['q', 'sortBy', 'sortDirection', 'page', 'locationIds', 'sourcingCampaignStatus'];

export const countJobsFilters = (filters) =>
  Object.keys(filters).reduce((carry, key) => {
    // Skip blacklisted filters
    if (blacklistedFiltersForCount.includes(key)) {
      return carry;
    }

    const filterValue = filters[key];
    const defaultValue = defaultJobsFilters[key];

    // If filter value exists and differs from default
    if (filterValue !== null && filterValue !== undefined && !isEqual(filterValue, defaultValue)) {
      // Check if it's an array with items
      if (Array.isArray(filterValue)) {
        if (filterValue.length > 0) {
          return carry + 1;
        }
      }
      // Check if it's an object with keys
      else if (typeof filterValue === 'object' && filterValue !== null) {
        if (Object.keys(filterValue).length > 0) {
          return carry + 1;
        }
      }
      // For primitive values (string, number, boolean)
      else if (filterValue !== '' && filterValue !== null && filterValue !== undefined) {
        return carry + 1;
      }
    }

    return carry;
  }, 0);

export default countJobsFilters;
